import { ReactElement } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import arrow from '../../../assets/arrow.svg'
import { Wrapper } from "../wrapper/wrapper"
import { AboutMoreProps } from "./about-props"
import * as S from './about-style'

export function AboutMore ({ id, ...props }: AboutMoreProps): ReactElement {
  return <S.Container id={id}>
    <S.BannerContainer>
      <Wrapper>
        <S.BannerWrapper>
          <S.BannerContent>
            <S.Title>O maior cartão de descontos do Brasil!</S.Title>
            <S.Description>Com ele você tem acesso a <strong>saúde</strong>, <strong>educação</strong>, <strong>lazer</strong> e <strong>dindin de volta</strong>!</S.Description>
          </S.BannerContent>
          <S.Divs>
            <S.Card>
              <S.CardTitle>Telemedicina</S.CardTitle>
              <S.List>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Clínico geral</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Cardiologia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Dermatologia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Psicologia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Geriatria</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Otorrinolaringologia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Pediatria</S.ListItem>
              </S.List>
              <p><strong>E muito mais!</strong></p>
            </S.Card>
            <S.Card>
              <S.CardTitle>Odontologia</S.CardTitle>
              <S.List>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Periodontia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Ortodontia</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Próteses</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Implantes</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Odontopediatria</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Lentes de contato</S.ListItem>
                <S.ListItem><S.Arrow src={arrow} alt="Arrow" />Clareamento</S.ListItem>
              </S.List>
              <p><strong>E muito mais!</strong></p>
            </S.Card>
          </S.Divs>
          <S.DesktopLink href={props.values.button.link}>{props.values.button.title}</S.DesktopLink>
          <S.MobileLink href={props.values.button.link}>{props.values.button.title}</S.MobileLink>
        </S.BannerWrapper>
      </Wrapper>
    </S.BannerContainer>
  </S.Container>
}